import * as React from "react";
import { Navigate } from "react-router";
import { Route } from "react-router-dom";
import { userInfoStore } from "Stores/UserInfoStore";

export const Logout = () => {
  React.useEffect(() => {
    userInfoStore.signOut("/logout", false);
  }, []);
  return <Route element={<Navigate to={{ pathname: "/login" }} />} />;
};
